import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\SendToAccountingController::__invoke
* @see app/Http/Controllers/Invoice/SendToAccountingController.php
* @route '/api/invoicing/{invoice}/send-to-accounting'
*/
const SendToAccountingController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SendToAccountingController.url(args, options),
    method: 'get',
})

SendToAccountingController.definition = {
    methods: ["get","head"],
    url: '/api/invoicing/{invoice}/send-to-accounting',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Invoice\SendToAccountingController::__invoke
* @see app/Http/Controllers/Invoice/SendToAccountingController.php
* @route '/api/invoicing/{invoice}/send-to-accounting'
*/
SendToAccountingController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return SendToAccountingController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\SendToAccountingController::__invoke
* @see app/Http/Controllers/Invoice/SendToAccountingController.php
* @route '/api/invoicing/{invoice}/send-to-accounting'
*/
SendToAccountingController.get = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SendToAccountingController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Invoice\SendToAccountingController::__invoke
* @see app/Http/Controllers/Invoice/SendToAccountingController.php
* @route '/api/invoicing/{invoice}/send-to-accounting'
*/
SendToAccountingController.head = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SendToAccountingController.url(args, options),
    method: 'head',
})

export default SendToAccountingController